
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Common from "../Common";
import Login_header from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import DatePicker from 'react-datepicker';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';


const TranPanWhitelisting = () => {
    const sid = sessionStorage.getItem('sessionId');
    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [srno, setSrNo] = useState(0);
    const [remark, setRemark] = useState("");
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showFormBtn, setShowFormBtn] = useState(false);
    const [scrMode, setScrMode] = useState('');
    const [pan, setPan] = useState("");
    const [oldStatus, setOldStatus] = useState('1'); // To store original status for update comparison
    const [searchPan, setSearchPan] = useState("");
    const [searchTillDate, setSearchTillDate] = useState(null);
    const [onceRun, setOnceRun] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [msgText, setMsgText] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [panwhitelistdata, setPanwhitelistdata] = useState([]);
    const [tilldate, setTillDate] = useState(new Date());
    const [counter, setCounter] = useState(0);
    const [file, setFile] = useState("");
    const [isClickedUpload, setIsClickedUpload] = useState(false);
    const [fileName, setFileName] = useState("");
    const [compareData, setCompareData] = useState([]);
    const [imagePath, setImagePath] = useState('');
    const [showDocument, setShowDocument] = useState(false);
    const [documentToView, setDocumentToView] = useState("");
    const [searchStatus, setSearchStatus] = useState("");
    const [status, setStatus] = useState("1");
    const [viewObj, setViewObj] = useState();
    const [statusUpdateRemark, setStatusUpdateRemark] = useState("");






    useEffect(() => {
        if (onceRun) return;
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_PAN_WHITELIST'], function (result) {
            if (result.trim().startsWith('{')) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            } else {
                console.error("Invalid response for rights:", result);
                navigate('/');
            }
        });
        setOnceRun(true);
    }, [onceRun, sid, navigate]);

    const handleShowPanList = () => {
        $(".loader").show();
        setCounter(counter + 1);
        const obj = {
            searchStatus: searchStatus,
            searchPan: searchPan,
            searchTillDate: searchTillDate ? Common.dateYMD(searchTillDate) : null
        }
        Common.callApi(Common.apiPanWhitelist, [sid, 'list', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setPanwhitelistdata(resp);
            $(".loader").hide();
        });
    }

    const handleAddNew = () => {
        setSrNo(0);
        setRemark("");
        setPan("");
        setScrMode('A');
        setShowAddNewBtn(false);
        setShowFormBtn(true);
        setTillDate(new Date());
        setIsClickedUpload(false);
        setOldStatus('1');
        setStatus('1')
        setFile();
        setImagePath('')
    };

    const handleCancelConfirmation = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            resetFormAndList();
        }
    }

    const resetFormAndList = () => {
        setMsgBoxYN(false);
        setShowFormBtn(false);
        setShowAddNewBtn(true);
        setScrMode("");
    }

    const validateFields = () => {
        const msg = ["Please fill All Mandatory Fields!"];
        if (scrMode === 'A') {
            if (!pan) msg.push("PAN");
            if (!remark) msg.push("Remark");
            if (!tilldate) msg.push("Till Date");
        } else {
            if (!statusUpdateRemark) msg.push("Status Update Remark");
        }
        return msg;
    };

    const saveBtnHandler = async () => {
        $(".loader").show();
        try {
            let validationErrors = validateFields();
            if (validationErrors.length > 1) {
                setMsgText(Common.buildMessageFromArray(validationErrors));
                setMsgBox(true);
                return;
            }
            if (scrMode === 'A') {//create new pan
                let imgName = "";
                if (file) {//if image is pleasent than upload first image
                    imgName = await uploadImage();
                    console.log(imgName);
                    if (!imgName) {//than uplaod data
                        setMsgText("Image upload failed.");
                        setMsgBox(true);
                    }
                }
                await savePanData(imgName);
            } else {//update 
                let imgName = "";
                if (file) {//if image is pleasent than upload first image
                    imgName = await uploadImage();
                    console.log(imgName);
                    if (!imgName) {//than uplaod data
                        setMsgText("Image upload failed.");
                        setMsgBox(true);
                    }
                }
                await savePanData(imgName);
            }
        } catch (error) {
            setMsgText(error.message || "Something went wrong. Please try again.");
            setMsgBox(true);
        } finally {
            $(".loader").hide();
        }
    };

    const uploadImage = async () => {
        if (!file) {
            var tempArray = document.getElementById('panImage').files[0].name.split('.');
            if (tempArray.length > 2) {
                // $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
                return;
            } else if (document.getElementById('panImage').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                // $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
                return;
            }
        } else {
            const obj = {
                srno: 8888, // This srno might need to be adjusted based on actual logic.
                uploadType: "uploadPAN",
                pageright: "TRAN_PAN_WHITELIST",
                pan: pan,
                remark: remark,
                sid: sid,
                tilldate: Common.dateYMD(tilldate),
            }
            return new Promise((resolve, reject) => {
                Common.uploadApi(JSON.stringify(obj), 'panImage', (result) => {
                    try {
                        const resp = JSON.parse(result);
                        console.log(resp);
                        if (resp.status) {
                            setIsClickedUpload(false);
                            resolve(resp.docdetail.filename); // Resolve filename
                        } else {
                            reject(new Error(resp.msg || "Image upload failed"));
                        }
                    } catch (err) {
                        reject(new Error("Invalid response from upload API"));
                    }
                });
            });
        }
    }
    const savePanData = async (uploadedFileName) => {
        const obj = {
            pan: pan,
            remark: remark,
            statusUpdateRemark: statusUpdateRemark,
            tilldate: Common.dateYMD(tilldate),
            filename: uploadedFileName,
            srno: srno,
            status: status,
            oldStatus: oldStatus
        };
        await Common.callApi(Common.apiPanWhitelist, [sid, 'save', JSON.stringify(obj)], (result) => {
            const resp = JSON.parse(result);
            if (resp.status) {
                setPanwhitelistdata(resp.list);
                setShowFormBtn(false);
                setShowAddNewBtn(true);
                setRemark("");
                setPan("");
                setScrMode('');
                setMsgText(resp.msg || "Successfully Saved!");
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        }
        );
    };

    const handleToggleFileUpload = () => {
        setIsClickedUpload(true);
    }

    const prepareCompareObject = (resp) => {
        const obj2 = {
            srno: resp.srno,
            pan: resp.pan,
            remark: resp.remark,
            tilldate: resp.tilldate
        };
        setCompareData([obj2]);
    }

    const populateEditForm = (srno) => {
        let obj = {
            srno: srno
        }
        Common.callApi(Common.apiPanWhitelist, [sid, 'view', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setSrNo(resp.tpw_srno);
            setPan(resp.tpw_pan);
            setRemark(resp.tpw_remark);
            setTillDate(new Date(resp.tpw_till_date));
            // setPanwhitelistdata([resp]);
            setViewObj(resp);
            prepareCompareObject(resp);
            setShowFormBtn(true);
            setShowAddNewBtn(false);
            setScrMode('Q');
            setImagePath(resp?.tpw_pan_image); // Set the image path
            setStatus(resp.tpw_active);
            setStatusUpdateRemark(resp.tpw_status_update_remark || '');
            setOldStatus(resp.tpw_active); // Set oldStatus from fetched status
            setFile()
            // setTpwExpiredBy(resp.tpw_expired_by);
            // setTpwExpiredTimestamp(resp.tpw_expired_timestamp);
        });
    };
    console.log(imagePath)

    const handleEdit = () => {
        setScrMode('E'); // Set screen mode to Edit

        // setFormMode('E'); // Set form mode to Edit
    };

    const handleViewPanImage = (srno) => {
        let obj = {
            srno: srno
        }
        setShowDocument(true);
        Common.callDocumentViewApi(Common.apiPanWhitelist, [sid, 'docview', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
        });
    };

    return (
        <div>
            <Login_header />
            <Menu />
            <Container fluid>
                <Row><Col><h1>PAN Whitelisting</h1></Col></Row>
                <Row><Col>&nbsp;</Col></Row>
                {scrMode === '' && showAddNewBtn && userRight.add === "1" &&
                    <>
                        <Row>
                            <Col className="divContentCenter">
                                <div className="maxFormWidth">
                                    {/* <Form>  */}
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>PAN</Form.Label>
                                                <Form.Control type="text" placeholder="PAN" maxLength={10}
                                                    value={searchPan}
                                                    onChange={(e) => setSearchPan(e.target.value)}
                                                    onBlur={(e) => Common.validatePan(e.target.value, setSearchPan)}
                                                    autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Till Date</Form.Label><br></br>
                                                <DatePicker className="form-control"
                                                    selected={searchTillDate}
                                                    onChange={(date) => setSearchTillDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Control as="select" value={searchStatus} onChange={(e) => setSearchStatus(e.target.value)}>
                                                    <option value="">All</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* </Form> */}
                                </div>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {sessionStorage.getItem('userSrno') === '1' &&
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={(e) => handleShowPanList()}>
                                        List
                                    </Button>

                                }
                                &nbsp;
                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleAddNew}>
                                    Add New
                                </Button>
                            </Col>
                        </Row>
                    </>
                }
                <Row>&nbsp;</Row>
                {
                    <Col>
                        {
                            (scrMode === 'L' || scrMode === 'A' || scrMode === 'Q') ? <>
                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                    handleCancelConfirmation()}>Back</Button>&nbsp;&nbsp;
                            </> : null
                        }
                        {
                            (userRight.delete === "1" && scrMode === 'Q' && oldStatus === '1') ? <>
                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={handleEdit}>Edit</Button>&nbsp;&nbsp;
                            </> : null
                        }
                        {
                            (userRight.add === "1" && (scrMode === 'A' || scrMode === 'E')) ? <>
                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                    saveBtnHandler()}>Save</Button>&nbsp;
                            </> : null
                        }
                    </Col>
                } &nbsp; &nbsp;

                {scrMode == '' && sessionStorage.getItem('userSrno') === '1' &&
                    <Row>
                        <Col>
                            <table className="table table-bordered table-sm">
                                <thead className="thead-light">
                                    <tr>
                                        {userRight.query == "1" && <th></th>}
                                        <th>PAN</th>
                                        <th>Created By</th>
                                        <th>Remark</th>
                                        <th>Till Date</th>
                                        {/* <th>Image</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {panwhitelistdata.map((item, index) => (
                                        item ? (
                                            <tr key={index + 1}>
                                                {scrMode !== 'Q' && userRight.query == "1" && (
                                                    <td className="textCenter">
                                                        <span className="handCursor" onClick={() => populateEditForm(item.tpw_srno)} >
                                                            <div className="colorThemeBlue">
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </div>
                                                        </span>
                                                    </td>
                                                )}
                                                <td>{item.tpw_pan}</td>
                                                <td>{item.tpw_created_by + ' ' + item.um_username}</td>
                                                <td>{item.tpw_remark}</td>
                                                <td>{item.tpw_till_date}</td>
                                            </tr>
                                        ) : null
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                }
                <Row><Col>&nbsp;</Col></Row>
                {showFormBtn && (scrMode === 'A' || scrMode === 'Q' || scrMode === 'E') &&
                    <Row>
                        <Col className="divContentCenter">
                            <div className="maxFormWidth">
                                {/* <Form> */}
                                {scrMode === 'Q' || scrMode === 'E' &&
                                    <Row>
                                        <Col>
                                            <p>Created By : <b>{(viewObj?.tpw_created_by || '') + ' ' + (viewObj?.created_by || '')}</b></p>
                                        </Col>
                                        <Col>
                                            <p>Created Date : <b>{viewObj?.tpw_create_timestamp || ''}</b></p>
                                        </Col>
                                        {viewObj?.tpw_expired_by &&
                                            <Col>
                                                <p>Expired By : <b>{(viewObj?.tpw_expired_by || '') + ' ' + (viewObj?.expired_by || '')}</b></p>
                                            </Col>
                                        }
                                        {viewObj?.tpw_expired_timestamp &&
                                            <Col>
                                                <p>Expired Date : <b>{viewObj?.tpw_expired_timestamp || ''}</b></p>
                                            </Col>
                                        }
                                    </Row>
                                }
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Serial Number</Form.Label>
                                            <Form.Control type="text" placeholder="Serial Number" value={srno} disabled />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>PAN<span className="mandatory text-danger">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="PAN" maxLength={10}
                                                value={pan}
                                                onChange={(e) => setPan(e.target.value)}

                                                disabled={scrMode === 'Q' || scrMode === 'E'}
                                                autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Till Date <span className=" text-danger">*</span></Form.Label><br></br>
                                            <DatePicker className="form-control"
                                                selected={tilldate}
                                                onChange={(date) => setTillDate(date)}
                                                disabled={scrMode === 'Q' || scrMode === 'E'}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Control as="select" value={status} onChange={(e) => setStatus(e.target.value)}
                                                disabled={scrMode === 'Q'}>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="align-items-end">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                value={remark}
                                                onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                disabled={scrMode === 'Q' || scrMode === 'E'}
                                                autoComplete="off"
                                                required />
                                        </Form.Group>
                                    </Col>
                                    {scrMode != 'A' &&
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Status Update Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Staus Update Remark" maxLength={50}
                                                    value={statusUpdateRemark}
                                                    onChange={(e) => Common.validateAlpValue(e.target.value, setStatusUpdateRemark)}
                                                    disabled={scrMode === 'Q'}
                                                    autoComplete="off"
                                                    required />
                                            </Form.Group>
                                        </Col>
                                    }
                                </Row>
                                {/* {scrMode === 'Q' && imagePath && (
                                        <Col>
                                            <div className="textCenter">
                                                <span className="handCursor" onClick={() => handleViewPanImage({ "srno": srno })}>
                                                    <div className="colorThemeBlue">
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </div>
                                                </span>
                                            </div>
                                        </Col>
                                    )} */}
                                {/* {scrMode === 'Q' && panwhitelistdata[0]?.tpwExpiredBy && (
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label>Expired By</Form.Label>
                                                <Form.Control type="text" value={panwhitelistdata[0]?.tpwExpiredBy} disabled />
                                            </Form.Group>
                                        </Col>
                                    )}
                                    {scrMode === 'Q' && panwhitelistdata[0]?.tpwExpiredTimestamp && (
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label>Expired Timestamp</Form.Label>
                                                <Form.Control type="text" value={panwhitelistdata[0]?.tpwExpiredTimestamp} disabled />
                                            </Form.Group>
                                        </Col>
                                    )} */}
                                {(scrMode === 'A' || scrMode === 'E') && !imagePath &&
                                    <Row >
                                        <Col md={6}>
                                            <Form.Group controlId="panImage">
                                                <Form.Label>Upload File<span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="file" onChange={e => setFile(e.target.files[0])} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                }
                                {(scrMode === 'Q' || scrMode === 'E') && imagePath &&
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group controlId="panImageView">
                                                <Form.Label>Pan Image</Form.Label>
                                                <div className="textCenter" style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <Form.Control type="text" value={imagePath} disabled='true' />
                                                    {/* <img src={`/api/upload/${imagePath}`} alt="Pan Image" style={{ maxWidth: '100%', maxHeight: '200px' }} /> */}
                                                    <span className="handCursor"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onClick={() => handleViewPanImage(srno)}>
                                                        <div className="colorThemeBlue">
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col>&nbsp;</Col></Row>
                                {/* </Form> */}
                            </div>
                        </Col>
                    </Row>
                }
                <Row>
                </Row>&nbsp;
            </Container>
            <Modal show={showDocument} onHide={() => setShowDocument(false)} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Pan Image
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <embed src={documentToView} type={documentTypeToView}
                        style={{ position: "relative", height: '100%',width:'100%' }} ></embed> */}
                    {/* <iframe
                        src={documentToView}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            objectFit: "contain"
                        }}
                    /> */}
                    <img src={documentToView}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            objectFit: "contain"
                        }} />

                </Modal.Body>
            </Modal>

            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => resetFormAndList()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </div >
    )
}

export default TranPanWhitelisting;
